import { useState, useEffect, useCallback } from "react";
import axios from "../utils/api";
import { isMarketOpen } from "../utils/marketUtils";

export function useMarketStatus() {
  const [marketOpen, setMarketOpen] = useState(isMarketOpen());
  const [marketData, setMarketData] = useState(null);

  /**
   * Memoized because callers put it in dependency arrays.
   *
   * As a plain function this was a new reference on every render, which made
   * runScan() in App new on every render, which made the auto-scan effect
   * re-run on every render — tearing down and restarting its own timers. Since
   * that effect ticks a countdown every second, and the tick re-renders App,
   * the schedule reset itself once a second and auto-scan never fired.
   */
  const fetchMarket = useCallback(async () => {
    try {
      const r = await axios.get("/api/market");
      setMarketData(r.data);
    } catch { /* non-critical */ }
  }, []);

  useEffect(() => {
    const t = setInterval(() => setMarketOpen(isMarketOpen()), 60000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => { fetchMarket(); }, []); // eslint-disable-line

  return { marketOpen, marketData, fetchMarket };
}
